import { SlugInput } from './SlugInput'
import { withSlugInput } from './withSlugInput'

const ConnectedTextInput = withSlugInput(SlugInput)

export { ConnectedTextInput as SlugInput }
